import { AutoColumn } from "components/Layout/Column";
import React from "react";
import { SkeletonCardActions, SkeletonCardDetails, SkeletonCardTokens } from "views/Igos/components/Offering/IgoCard/Skeletons";
import { FixedHeightRow, StyledCard } from "../styles";

const SkeletonCard: React.FC = () => {
  return <StyledCard>
    <AutoColumn gap="8px" style={{ padding: '16px' }}>
      <SkeletonCardTokens />
      <FixedHeightRow />
      <SkeletonCardDetails />
      <FixedHeightRow />
      <FixedHeightRow />
      <SkeletonCardActions />
    </AutoColumn>
  </StyledCard>
}

export default SkeletonCard